export default __webpack_public_path__ + "assets/Reporter1.png";